"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSelectedRechargesProvider = exports.useSelectedRecharges = void 0;
var SelectedIdsContext_1 = require("utils/contexts/SelectedIdsContext");
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var SelectedRechargesContext = (0, SelectedIdsContext_1.makeSelectedIdsContext)();
exports.useSelectedRecharges = (0, SelectedIdsContext_1.makeUseSelectedIdsContext)(SelectedRechargesContext);
exports.withSelectedRechargesProvider = (0, SelectedIdsContext_1.withSelectedIdsProvider)(SelectedRechargesContext, populatedDerived_1.selectPopRechargesData);
